import { render } from "./ErrorpageComponent.vue?vue&type=template&id=48e89e9e"
import script from "./ErrorpageComponent.vue?vue&type=script&lang=js"
export * from "./ErrorpageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__